import React, { useContext, useEffect } from 'react';
import { buriedPoint, typeIdObj } from '@/pages/home/utils/buriedPoint';
import { StudioContext } from '../context';
import StudioState from '../components/StudioState';
import { IframeUrl } from '@home/components/IframeUrl';

const Web = () => {
  const { currentGame, currentMenu, menuPermission } = useContext(StudioContext);
  useEffect(()=> {
    if(!currentMenu){
      return;
    }

    const { unified_edition_id: unifiedId, id_type: idType } = currentGame;
    const { id = '', name_en: nameEn } = currentMenu || {};
    const logObj = {
      pageId: '902901', 
      menuId: id,
      pageName: nameEn,
      extInfo: nameEn,
      pagePath: `/web/report/${nameEn || ''}`,
      uid: unifiedId || '',
      typeId: typeIdObj.studio,
      gameName: currentGame?.game_name,
      uidType: idType
    };
    buriedPoint(logObj);

  },[currentGame, currentMenu]);

  if (menuPermission === false) {
    return <StudioState isNoPermission={true} />;
  }

  return (
    <>
      {
        currentMenu?.url ? <IframeUrl url={currentMenu?.url} className='db-studio-iframe-wrap'/> : <StudioState/>
      }
    </>
  );
};

export default Web;